import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const Hypothesis: React.FC<SvgIconProps> = ({ ...props }) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20" sx={{ fill: "none" }}>
      <rect width="20" height="20" rx="4" fill="#EC0089" />
      <path
        d="M10 4C11.0609 4 12.0783 4.4425 12.8284 5.23015C13.5786 6.0178 14 7.08609 14 8.2C14 9.628 13.32 10.882 12.2857 11.644V13C12.2857 13.1591 12.2255 13.3117 12.1183 13.4243C12.0112 13.5368 11.8658 13.6 11.7143 13.6H8.28571C8.13416 13.6 7.98882 13.5368 7.88165 13.4243C7.77449 13.3117 7.71429 13.1591 7.71429 13V11.644C6.68 10.882 6 9.628 6 8.2C6 7.08609 6.42143 6.0178 7.17157 5.23015C7.92172 4.4425 8.93913 4 10 4ZM8.28571 15.4V14.8H11.7143V15.4C11.7143 15.5591 11.6541 15.7117 11.5469 15.8243C11.4398 15.9368 11.2944 16 11.1429 16H8.85714C8.70559 16 8.56025 15.9368 8.45308 15.8243C8.34592 15.7117 8.28571 15.5591 8.28571 15.4ZM10 5.2C9.24224 5.2 8.51551 5.51607 7.97969 6.07868C7.44388 6.64129 7.14286 7.40435 7.14286 8.2C7.14286 9.43 7.84571 10.486 8.85714 10.948V12.4H11.1429V10.948C12.1543 10.486 12.8571 9.43 12.8571 8.2C12.8571 7.40435 12.5561 6.64129 12.0203 6.07868C11.4845 5.51607 10.7578 5.2 10 5.2Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export default Hypothesis;
